import { useState, useEffect} from "react";
import {  CampaignModel, listAnalyses} from "../../../../services/analysisService";
import { useLanguage } from "LanguageContext";
import Autocomplete from "./../../../CommonUi/Autocomplete/Autocomplete";

interface CampaignTextFieldProps {
  setCampaign: (project: CampaignModel | null) => void;
  campaignName: string | null;
  project?: string | null;
  analysis?: string | null;
}

export default function CampaignTextField(
  props: Readonly<CampaignTextFieldProps>
) {
  const { t } = useLanguage();
  const [campaigns, setCampaigns] = useState<string[]>([]);
  const [_analyses, setAnalyses] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [campaignName, setCampaignName] = useState<string>(props?.campaignName || "");

  function fetchCampaigns(analyses : any = []) {
      if (!analyses?.length) {
        setLoading(false);
        return false;
      };
      let result = analyses || [];
      if (props?.project && analyses?.length > 0) {
        result = result.filter((item: any) => item.project?.id === props?.project);
      }
      const campaignsList = new Set<string>(result.map((result: any) => result.name));
      setCampaigns([...campaignsList].sort((a, b) => a.localeCompare(b)));
      setLoading(false);
  }

  useEffect(() => {  
    setLoading(true);
    if (!props?.analysis) {
      listAnalyses({ sortingColumns: {} }).then((res: any) => {
        if (res?.results?.length > 0) {
          setAnalyses(res?.results || []);
          fetchCampaigns(res?.results || []);
        }
      });
    } else if (props?.analysis?.length > 0) {
      fetchCampaigns(props?.analysis || []);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    if (!props?.analysis && _analyses?.length > 0) {
      fetchCampaigns(_analyses);
    } else if (props?.analysis && props?.analysis?.length > 0) {
      fetchCampaigns(props?.analysis);
    } else {
      setLoading(false);
    }
  }, [props?.project]);

  useEffect(() => {
    props.setCampaign(campaignName ? { name: campaignName } : null);
  }, [campaignName]);
  
  return (
    <Autocomplete
      data={campaigns}
      setAutocompleteValue={setCampaignName}
      autocompleteLable={t("analyse_form_label_campaign")}
      autocompletePlaceholder={t("analyse_form_placeholder_campaign")}
      autocompleteValue={campaignName || ""}
      addnewButtonPrefix={t("project_add_new")}
      focuseNext={() => {}}
      props={{
        name: "campaignName",
        disabled: loading,
      }}
    />
  );
}